import { FlattenedItem, TreeNode } from '@/common/components/Tree/TreeItemView/TreeItemView.types';

export function removeChildrenOf<T extends TreeNode<T>>(items: FlattenedItem<T>[], ids: StringOrNumber[]) {
  const excludeParentIds = [...ids];

  return items.filter((item) => {
    if (item.parentId && excludeParentIds.includes(item.parentId)) {
      if (item.original.children?.length) {
        excludeParentIds.push(item.id);
      }

      return false;
    }

    return true;
  });
}

export function flattenTree<T extends TreeNode<T>>(items: T[]): FlattenedItem<T>[] {
  return flatten(items);
}

export function flatten<T extends TreeNode<T>>(
  items: T[],
  parentId: Nullable<StringOrNumber> = null,
  depth = 0,
): FlattenedItem<T>[] {
  return items.reduce<FlattenedItem<T>[]>((acc, item, index) => {
    const flattened: FlattenedItem<T> = {
      id: item.id,
      parentId,
      original: item,
      depth,
      collapsed: !!item.collapsed,
      index,
    };

    const flattenedChildren = flatten(item.children ?? [], item.id, depth + 1);

    return [...acc, flattened, ...flattenedChildren];
  }, []);
}
